import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectionRoutes = () => {
    const authLocal = localStorage.getItem('users');
    return authLocal ? <Outlet /> : <Navigate to={'/auth/login'} replace />;
}

export default ProtectionRoutes;